module.exports = __webpack_public_path__ + "static/media/transfered-player.svg.ab7bccb8.png";